export const BANK_ACCOUNT_LIST_ATTEMPT = "BANK_ACCOUNT_LIST_ATTEMPT";
export const BANK_ACCOUNT_LIST_SUCCESS = "BANK_ACCOUNT_LIST_SUCCESS";
export const BANK_ACCOUNT_LIST_FAILED = "BANK_ACCOUNT_LIST_FAILED";
///////////////////////////
export const BANK_ACCOUNT_SAVE_ATTEMPT = "BANK_ACCOUNT_SAVE_ATTEMPT";
export const BANK_ACCOUNT_SAVE_SUCCESS = "BANK_ACCOUNT_SAVE_SUCCESS";
export const BANK_ACCOUNT_SAVE_FAILED = "BANK_ACCOUNT_SAVE_FAILED";
